import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name text-select
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMjFoMSIgLz4KICA8cGF0aCBkPSJNMTQgM2gxIiAvPgogIDxwYXRoIGQ9Ik0xOSAzYTIgMiAwIDAgMSAyIDIiIC8+CiAgPHBhdGggZD0iTTIxIDE0djEiIC8+CiAgPHBhdGggZD0iTTIxIDE5YTIgMiAwIDAgMS0yIDIiIC8+CiAgPHBhdGggZD0iTTIxIDl2MSIgLz4KICA8cGF0aCBkPSJNMyAxNHYxIiAvPgogIDxwYXRoIGQ9Ik0zIDl2MSIgLz4KICA8cGF0aCBkPSJNNSAyMWEyIDIgMCAwIDEtMi0yIiAvPgogIDxwYXRoIGQ9Ik01IDNhMiAyIDAgMCAwLTIgMiIgLz4KICA8cGF0aCBkPSJNNyAxMmgxMCIgLz4KICA8cGF0aCBkPSJNNyAxNmg2IiAvPgogIDxwYXRoIGQ9Ik03IDhoOCIgLz4KICA8cGF0aCBkPSJNOSAyMWgxIiAvPgogIDxwYXRoIGQ9Ik05IDNoMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/text-select
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const TextSelect: IconNode = [
  ['path', { d: 'M14 21h1' }],
  ['path', { d: 'M14 3h1' }],
  ['path', { d: 'M19 3a2 2 0 0 1 2 2' }],
  ['path', { d: 'M21 14v1' }],
  ['path', { d: 'M21 19a2 2 0 0 1-2 2' }],
  ['path', { d: 'M21 9v1' }],
  ['path', { d: 'M3 14v1' }],
  ['path', { d: 'M3 9v1' }],
  ['path', { d: 'M5 21a2 2 0 0 1-2-2' }],
  ['path', { d: 'M5 3a2 2 0 0 0-2 2' }],
  ['path', { d: 'M7 12h10' }],
  ['path', { d: 'M7 16h6' }],
  ['path', { d: 'M7 8h8' }],
  ['path', { d: 'M9 21h1' }],
  ['path', { d: 'M9 3h1' }],
];

export default TextSelect;
